module.exports = __webpack_public_path__ + "img/shipped-cross-sell-background.3e5b9e4.png";